import createSvgIcon from '../Utils/CreateSvgIcon';

export const Language = createSvgIcon(
  <path d="m11.842 21.1 4.095-10.86h1.855L22 21.1h-1.968l-.928-2.851H14.76l-1.063 2.85h-1.855Zm3.416-4.435h3.213l-1.584-4.389h-.045l-1.584 4.39Zm-10.543 1.72L3.47 17.14l4.615-4.615a19.862 19.862 0 0 1-1.527-2.002A15.38 15.38 0 0 1 5.394 8.43h1.968c.256.498.54.969.848 1.414.31.445.66.901 1.052 1.369a12.238 12.238 0 0 0 1.697-2.206c.453-.762.837-1.558 1.154-2.387H2V4.81h6.335V3h1.81v1.81h6.335v1.81h-2.557A17.259 17.259 0 0 1 12.6 9.686a15.817 15.817 0 0 1-2.025 2.861l2.217 2.24-.679 1.833-2.873-2.76-4.525 4.525Z" />,
  'Language',
);
